import { isDefined } from '../../common/predicates';
export async function* fetchAssetModelsFromQuery({ queries, assetModuleSession, }) {
    const assetQueries = queries
        .map((query) => ('assets' in query ? query.assets : undefined))
        .filter(isDefined);
    for (const assets of assetQueries) {
        for (const asset of assets) {
            try {
                const { assetModelId } = await assetModuleSession.fetchAssetSummary({
                    assetId: asset.assetId,
                });
                const assetModelResponse = assetModelId &&
                    (await assetModuleSession.fetchAssetModel({ assetModelId }));
                const maybeModeledDataStreams = await Promise.all(asset.properties.map((property) => assetModuleSession.describeModeledDataStream({
                    assetPropertyId: property.propertyId,
                    assetId: asset.assetId,
                    assetModelId: assetModelId !== null && assetModelId !== void 0 ? assetModelId : '',
                })));
                const modeledDataStreams = maybeModeledDataStreams.filter((ds) => ds != null);
                if (assetModelResponse) {
                    yield {
                        assetModels: { [asset.assetId]: assetModelResponse },
                        modeledDataStreams,
                    };
                }
            }
            catch (err) {
                yield { errors: { [asset.assetId]: err } };
            }
        }
    }
}
